import type { WhatsNewAction } from "domains/whatsNew/actionTypes";
import { WhatsNewActionType } from "domains/whatsNew/actionTypes";
import type { WhatsNewState } from "domains/whatsNew/types";

const initialState: WhatsNewState = { data: undefined };

export const whatsNewReducer = (state = initialState, action: WhatsNewAction): WhatsNewState => {
  switch (action.type) {
    case WhatsNewActionType.FETCH_FULFILLED:
      return !action.payload?.manifest ? state : { ...state, data: action.payload.manifest };
    case WhatsNewActionType.FETCH_REJECTED:
      return { ...state, data: undefined };
    default:
      return state;
  }
};
